const adminsHeader = (editAction, deleteAction) =>  [
  {
    name: 'Buyer number',
    sortable: true,
    selector: row => row.buyer,
  },
  {
    name: 'Auction',
    sortable: true,
    selector: row => row.auction,
  },
  {
    name: 'Comment',
    sortable: true,
    selector: row => row.comment,
  },
  {
    name: 'Actions',
    button: true,
		cell: (row) => (
      <span className="actions-container">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          onClick={() => editAction(row)}
          style={{ marginRight: '10px' }}
          xmlnsXlink="http://www.w3.org/1999/xlink"
          fill="#000000"
          version="1.1"
          id="Capa_1"
          width="20px"
          height="20px"
          viewBox="0 0 528.899 528.899"
          xmlSpace="preserve"
        >
          <g>
            <path d="M328.883,89.125l107.59,107.589l-272.34,272.34L56.604,361.465L328.883,89.125z M518.113,63.177l-47.981-47.981   c-18.543-18.543-48.653-18.543-67.259,0l-45.961,45.961l107.59,107.59l53.611-53.611   C532.495,100.753,532.495,77.559,518.113,63.177z M0.3,512.69c-1.958,8.812,5.998,16.708,14.811,14.565l119.891-29.069   L27.473,390.597L0.3,512.69z" />
          </g>
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          onClick={() => deleteAction(row)}
          xmlnsXlink="http://www.w3.org/1999/xlink"
          fill="#000000"
          version="1.1"
          id="Capa_1"
          width="20px"
          height="20px"
          viewBox="0 0 408.483 408.483"
          xmlSpace="preserve"
        >
          <g>
            <g>
              <path d="M87.748,388.784c0.461,11.01,9.521,19.699,20.539,19.699h191.911c11.018,0,20.078-8.689,20.539-19.699l13.705-289.316    H74.043L87.748,388.784z M247.655,171.329c0-4.61,3.738-8.349,8.35-8.349h13.355c4.609,0,8.35,3.738,8.35,8.349v165.293    c0,4.611-3.738,8.349-8.35,8.349h-13.355c-4.61,0-8.35-3.736-8.35-8.349V171.329z M189.216,171.329    c0-4.61,3.738-8.349,8.349-8.349h13.355c4.609,0,8.349,3.738,8.349,8.349v165.293c0,4.611-3.737,8.349-8.349,8.349h-13.355    c-4.61,0-8.349-3.736-8.349-8.349V171.329L189.216,171.329z M130.775,171.329c0-4.61,3.738-8.349,8.349-8.349h13.356    c4.61,0,8.349,3.738,8.349,8.349v165.293c0,4.611-3.738,8.349-8.349,8.349h-13.356c-4.61,0-8.349-3.736-8.349-8.349V171.329z" />
              <path d="M343.567,21.043h-88.535V4.305c0-2.377-1.927-4.305-4.305-4.305h-92.971c-2.377,0-4.304,1.928-4.304,4.305v16.737H64.916    c-7.125,0-12.9,5.776-12.9,12.901V74.47h304.451V33.944C356.467,26.819,350.692,21.043,343.567,21.043z" />
            </g>
          </g>
        </svg>
      </span>
      ),
  },
]

export default adminsHeader
